export const ESCALATED = 'escalated';
export const ASSESSMENT_COMPLETED = 'completed';
export const REGULAR_ASSESSMENT = "regular";
export const STANDARD_ASSESSMENT = "Standard";
export const REQUESTS= 'REQUESTS';
export const ASSESSMENTS='ASSESSMENTS';
export const COMPANION='COMPANION';
